// 类别
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>
    <!-- 类型里面的详情  每一行两列   每一个有一个图片、一个名字、一个查看详情 -->

    <div style="margin-top:4rem">
        <div v-for="(list,i) in lists" :key="i" class="list" v-if="i%2 == 0">
            <!-- 列的第一个 -->
                <el-card class="box1">
                <img class="img" :src="list.cover">
                <div class="text">
                    {{list.name}}
                </div>
                <div class="link">
                <div class="link1" @click="toLinkDetail(list.id)">
                    查看详情
                </div>
                </div>
                </el-card>
            <!-- 列的第二个 -->
            <div  v-if='i+1<lists.length'>
                <el-card class="box2">
                    <img class="img" :src="lists[i+1].cover">
                <div class="text">
                    {{lists[i+1].name}}
                </div>
                <div class="link">
                <div class="link1" @click="toLinkDetail(lists[i+1].id)">
                    查看详情
                </div>
                </div>
                </el-card>
            </div>
        </div>
    </div>
<div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'

export default {
  name: 'category',
  components: {
    // Header,
    Tabbar,
    Logo,
  },
  created () {
    this.getCategoryList()
  },
  methods: {
    toLinkDetail (id) {
      this.$router.push({
        path: '/services/servicesList/category/detail',
        query: {
          id: id
        }
      })
    },
    async getCategoryList () {
      const { data: data } = await api.getCategoryList(this.$route.query.id, 0)

      if (data.code === 200) {
        this.lists = data.data
        console.log('产品列表', this.lists)
      }
      if (window.localStorage.getItem('services')){
          var image1 = JSON.parse(window.localStorage.getItem('services'))
          this.image = image1.data.data.image
      }
    }
  },
  data () {
    return {
      lists: [],
      image: '',
    }
  },
}
</script>
<style scoped>
.link1 {
  text-decoration: none;
  color: #0099da;
  font-size: 1.5rem;
}

/deep/ .link {
  padding-top: 1.125rem !important;
  text-align: center;
}
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 24.125rem;
}
.text {
  max-width: 21.25rem;
  margin-top: 2.125rem;
  text-align: center;
  white-space:nowrap;
}
.img {
  margin-top: 2.3125rem;
  margin-left: 5.8125rem;
  width: 9.6875rem;
  height: 10.6875rem;
}
.list {
  display: flex;
  justify-content: space-between;
}
.box1 {
  width: 21.25rem;
  height: 22rem;
  margin-left: 1.5rem;
  margin-bottom: 2rem;
}
.box2 {
  width: 21.25rem;
  height: 22rem;
  margin-right: 1.5rem;
  margin-bottom: 2rem;
}

/* card边框 */
/deep/ .el-card__body {
  padding: 0rem !important;
  height: 22rem;
}
</style>
